// Use ErrorSlug when error messages should be translated wiht i18n.
// Add translations in client sv.json notifications.cesgErrorSlug
export var CesgErrorSlug;
(function (CesgErrorSlug) {
    CesgErrorSlug["CantSetAdminRole"] = "CantSetAdminRole";
    CesgErrorSlug["ReviewRankingNotContinuous"] = "ReviewRankingNotContinuous";
})(CesgErrorSlug || (CesgErrorSlug = {}));
export class CesgError extends Error {
    slug;
    constructor(props) {
        if (typeof props === 'string') {
            super(props);
        }
        else {
            super(props.message);
            this.slug = props.slug;
        }
    }
}
